import React from 'react';
import { GroupIcon } from '../../appearence/icons/group_icon';
import { useTranslation } from 'react-i18next';
import { popupOpenService } from '../../shared/popupOpenService';
import { POPUP_KEY_ASSIGN_GROUP } from '../../constant';
import { Button } from '@chapche/ui';

const PreferencesListSelectAssignGroup = () => {
    const { i18n } = useTranslation();
    return (
        <Button className="gap-8" onClick={() => popupOpenService.callToOpen(POPUP_KEY_ASSIGN_GROUP)}>
            <GroupIcon/>
            {i18n.t('app.page.preference.assignGroup')}
        </Button>
    );
};

export default PreferencesListSelectAssignGroup;
